<script type="text/jsx">
import ConfigCycleV2 from '@/components/service/config-billing-cycle/v2/index';
import { BILLING_CYCLE } from '@/common/constants';

export default {
  name: 'config-cycle-v2-free-trial',
  extends: ConfigCycleV2,
  render() {
    const label = `${this.planName} Free Trial`;

    if (this.textViewModel) {
      return <config-text-row title={this.$t('billing.plan')} value={this.billingCycleOptions?.[0]?.options?.[0]?.cycleLabel} />
    }

    return <div class='opc-select-cycle'>
      <cycle-select
        inline-label={this.$t('billing.plan')}
        popper-append-to-body
        value={this.billingCycle}
        plans={this.currentGroupPlanList}
        aria-label={label}
        label={label}
        action={this.switchBillingCycle}
        onInput={this.changeBillingCycle}
        className="opc-capacity-config-row__capacity--select"
        post-label={this.getSavePercentLabel(this.billingCycle === BILLING_CYCLE.ANNUAL)}
        popper-class='opc-capacity-config-row__capacity--popper'>
        {
          this.billingCycle === BILLING_CYCLE.ANNUAL ?
          <save-count
            slot="post"
            annual-price={this.currentPlanCyclePrice?.annual}
            monthly-price={this.currentPlanCyclePrice?.monthly} />
            : null
        }
        {this.billingCycleOptions.map((group) => {
          return <zm-option-group
            key={group.label}
            label={group.label}>
            {group.options.map((p) => {
              return <opc-option
                data-testid={`checkout-radio-billing-cycle-${p.billing_cycle}`}
                key={p.billing_cycle}
                disabled={p.disabled}
                value={p.billing_cycle}
                label={p.cycleLabel}
                post-label={this.getSavePercentLabel(p.billing_cycle === BILLING_CYCLE.ANNUAL)}
              >
                <opc-option-item
                  annual-price={this.currentPlanCyclePrice?.annual}
                  monthly-price={this.currentPlanCyclePrice?.monthly}
                  is-show-save-count={p.billing_cycle === BILLING_CYCLE.ANNUAL}
                  label={p.cycleLabel}
                  disabled={p.disabled}
                  tooltip-content={p.tooltips} />
              </opc-option>
            })}
          </zm-option-group>
        })}
      </cycle-select>
    </div>;
  },
};
</script>
